const PageNotFound = (_:any)=> {
    return <div>
        <p>Page Not Found</p>
    </div>
}

export default PageNotFound;